import React from "react";
import "./blog.css";
import blog1 from "./blog-img-1.jpg";
import blog2 from "./blog-img-2.jpg";
import blog3 from "./blog-img-3.jpg";
import blog4 from "./blog-img-4.jpg";

export const Blog = () => {
  return (
    <div className="blog">
      <div class="row g-4 row-cols-1 row-cols-lg-4 row-cols-md-4">
        <div class="feature col">
          <div class="feature-icon bg-primary bg-gradient">
            {/* <svg class="bd-placeholder-img card-img-top" width="100%" height="200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#55595c"></rect><text x="50%" y="50%" fill="#eceeef" dy=".3em">Thumbnail</text></svg> */}
            <img src={blog1} class="bd-placeholder-img card-img-top" alt="Blog Image" />
          </div>
          <h4>Blog title</h4>
          <p>
            Paragraph of text beneath the heading to explain the heading. We'll
            add onto it with another sentence and probably just keep going until
            we run out of words.
          </p>
          <a href="#" class="icon-link">
            Read more >
            {/* <svg class="bi" width="1em" height="1em">
              <use xlinkHref="#chevron-right"></use>
            </svg> */}
          </a>
        </div>
        <div class="feature col">
          <div class="feature-icon bg-primary bg-gradient">
            <img src={blog2} class="bd-placeholder-img card-img-top" alt="" />
          </div>
          <h4>Blog title</h4>
          <p>
            Paragraph of text beneath the heading to explain the heading. We'll
            add onto it with another sentence and probably just keep going until
            we run out of words.
          </p>
          <a href="#" class="icon-link">
            Read more >
          </a>
        </div>
        <div class="feature col">
          <div class="feature-icon bg-primary bg-gradient">
            <img src={blog3} class="bd-placeholder-img card-img-top" alt="" />
          </div>
          <h4>Blog title</h4>
          <p>
            Paragraph of text beneath the heading to explain the heading. We'll
            add onto it with another sentence and probably just keep going until
            we run out of words.
          </p>
          <a href="#" class="icon-link">
            Read more >
          </a>
        </div>
        <div class="feature col">
          <div class="feature-icon bg-primary bg-gradient">
            <img src={blog4} class="bd-placeholder-img card-img-top" alt="" />
          </div>
          <h4>Blog title</h4>
          <p>
            Paragraph of text beneath the heading to explain the heading. We'll
            add onto it with another sentence and probably just keep going until
            we run out of words.
          </p>
          <a href="#" class="icon-link">
            Read more >
          </a>
        </div>
      </div>
    </div>
  );
};
